export const inputDefaultStyles = {
  borderRadius: '0.25rem',
  borderColor: 'gray.200',
  errorBorderColor: 'red.500',
  lineHeight: '2rem',
  _disabled: { backgroundColor: 'gray.50', cursor: 'not-allowed', color: 'gray.500' },
};
